import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { event, hero } from '../data/masterclass';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-ink" data-id="element-65" data-mp="9lv16qmocfvu">
      <img src={event.backdropUrl} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-70" data-id="element-66" data-mp="4lyw0o28qiep" />
      <div className="absolute inset-0 -z-10 bg-ink/65" aria-hidden="true" data-id="element-67" data-mp="127edlbj0jlce" />

      <div className="mx-auto w-full max-w-7xl px-6 pb-20 pt-8 lg:px-10 lg:pb-28" data-id="element-68" data-mp="xaxe5l6d5kk0">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-20 w-20 object-contain sm:h-24 sm:w-24" data-id="element-69" data-mp="sa9n4zi4x3ps" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: EASE
      }} className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-70" data-mp="3d1ildbzsjgoh">
          <h1 className="font-display text-5xl font-bold uppercase leading-[0.95] tracking-[0.005em] text-white sm:text-6xl lg:text-7xl" style={{
          textWrap: 'balance'
        }} data-id="element-71" data-mp="3j9kbdcsl9jgn">
            Can your relationship carry the weight of your{' '}
            <span className="text-gold" data-id="element-72" data-mp="3e963buqzm9im">success?</span>
          </h1>

          <div className="mt-8 max-w-[58ch] space-y-5" data-id="element-73" data-mp="3ebioegs1kzzw">
            {hero.support.map(line => <p key={line} className="text-lg leading-[1.75] text-white/75" data-id="element-74" data-mp="30g6lhm3qg37w">
                {line}
              </p>)}
          </div>

          <p className="mt-12 border-y border-gold/25 px-8 py-5 text-sm font-semibold uppercase tracking-[0.14em] text-gold-pale" data-id="element-75" data-mp="2qkwjuzh8xxun">
            {event.eventLine}
          </p>

          <a href="#pricing" className="group mt-8 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-gold underline-offset-8 transition-colors duration-200 ease-out hover:text-gold-pale hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-76" data-mp="2hjf3dfzxfu5f">
            $97 per couple · See the two ways to join
            <ArrowDownIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden="true" data-id="element-77" data-mp="id9r45wihxq4" />
          </a>
        </motion.div>
      </div>
    </header>;
}